module.exports = __webpack_public_path__ + "static/img/5.65da7cc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/zh/5.png
// module id = 0bBq
// module chunks = 0